import React, { memo } from "react";
import ReactDatePicker, { ReactDatePickerProps } from "react-datepicker";
import Modal from "@components/modal/Modal";
import "./DatePicker.scss";
import dayjs from "dayjs";
import { useWidth } from "@utils/demenstion";
import { CircularProgress } from "@mui/material";

interface DatePickerProps extends ReactDatePickerProps {
  title?: string;
  error?: string;
  touched?: boolean;
  mobileScreen?: boolean;
  placeholder?: string;
  disabled?: boolean;
  isLoading?: boolean;
}

const DatePicker = (props: DatePickerProps) => {
  const [isOpen, setIsOpen] = React.useState(false);
  return (
    <div className="formElements__group">
      {props.title ? (
        <label className="formElements__label">{props.title}</label>
      ) : null}
      {props.mobileScreen ? null : (
        <div className="DatePicker__desktop">
          <ReactDatePicker
            fixedHeight
            inline
            className={`w-100  formElements__date ${
              props.touched && props.error ? "formElements__errorBorder" : ""
            }
          `}
            peekNextMonth
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            dateFormat="dd/MM/yyyy"
            placeholderText="Select a date"
            {...props}
          />
        </div>
      )}
      <div className={props.mobileScreen ? "" : "DatePicker__mobile"}>
        <div className="flex flex-row items-center">
          <input
            className={`w-100 form-control formElements__input
          ${props.touched && props.error ? "formElements__errorBorder" : ""}`}
            type="button"
            value={
              props.selected ? dayjs(props.selected).format("DD/MM/YYYY") : ""
            }
            onClick={() => setIsOpen(true)}
            placeholder={props.placeholder}
            disabled={props.disabled || props.isLoading}
          />
          {props.isLoading ? (
            <CircularProgress
              style={{ color: "blue", marginLeft: 10 }}
              size={20}
            ></CircularProgress>
          ) : null}
        </div>
        {props.touched && props.error ? (
          <div className="formElements__errorText">{props.error}</div>
        ) : null}
        <Modal
          handleClose={() => setIsOpen(false)}
          showModal={isOpen}
          maxWidth={useWidth() > 768 ? 500 : "100%"}
        >
          <div className={" DatePicker__mobile--whapper"}>
            <ReactDatePicker
              fixedHeight
              inline
              className={`w-100  formElements__date ${
                props.touched && props.error ? "formElements__errorBorder" : ""
              }
          `}
              peekNextMonth
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
              dateFormat="dd/MM/yyyy"
              placeholderText="Select a date"
              {...props}
              onChange={(dateVal: Date) => {
                props.onChange(dateVal, undefined);
                setIsOpen(false);
              }}
            />
          </div>
        </Modal>
      </div>
    </div>
  );
};

export default memo(DatePicker);
